import type { SxProps, Theme } from '@mui/material'

/**
 * Combina estilos sx na ordem recebida, achatando arrays e descartando valores ausentes. O tema é
 * genérico porque os componentes do @mui/x-chat tipam o sx com o Theme do @mui/system
 */
export function mergeSx<StyleTheme extends object = Theme>(
  ...styles: (SxProps<StyleTheme> | boolean | null | undefined)[]
): SxProps<StyleTheme> {
  const result = styles.flatMap(style => {
    if (style === null || style === undefined) {
      return []
    }
    if (Array.isArray(style)) {
      return style as SxProps<StyleTheme>[]
    }
    return [style]
  })

  return result as SxProps<StyleTheme>
}
